import { render, staticRenderFns } from "./SidebarToggle.vue?vue&type=template&id=19e72b06&lang=pug&"
import script from "./SidebarToggle.vue?vue&type=script&lang=ts&"
export * from "./SidebarToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports